import React from "react";
import ReactSelect from "react-select";
import { selectStyles } from "./styles";

const Select = ({ options, onChange, value, disabled, styles=selectStyles, placeholder="Seleccionar" }) => {
  return (
    <ReactSelect
      options={options}
      onChange={onChange}
      styles={styles}
      value={value || ""}
      placeholder={placeholder}
      isDisabled={disabled}
    />
  );
};

export default Select;